












































































































































































































































































import {Emit, Watch} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Achat, Client, Vente} from '@/models';

import storeVente from '@/stores/modules/vente';

import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
import CrudClientSearch from "@/components/Crud/Client/Search.vue";
import CrudLongueursVenteSearch from "@/components/Crud/LongueursVente/Search.vue";
import CrudBoisTypeSearch from "@/components/Crud/BoisType/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputLongueursVente from "@/components/Input/LongueursVente.vue";
import InputDatePicker from "@/components/Input/DatePicker.vue";
import {storeClientPrix} from "@/stores/modules/client";
import {Stored} from "vue-stored-prop-decorator/index";
import storeFournisseur, {FournisseurFilter} from "@/stores/modules/fournisseur";
import storeTransporteur from "@/stores/modules/transporteur";
import storeClient from "@/stores/modules/client";
import storeCommande from "@/stores/modules/commande";
import CrudClientEditDialog from "@/components/Crud/Client/EditDialog.vue";
import storeLongueursVente from "@/stores/modules/longueursVente";
import storeBoisType from "@/stores/modules/boisType";

@Component({
	components: {
		CrudTransporteurSearch,
		CrudClientSearch,
		CrudLongueursVenteSearch,
		CrudBoisTypeSearch,
		InputBoisType,
		InputLongueursVente,
		InputDatePicker,
		CrudClientEditDialog,
	}
})
export default class CrudVenteEdit extends AbstractEditVue<Vente> {

	// DF: utiliser pour la création d'un vente uniquement
	// en modification on passe par la light
	private step: number = 1;
	private savedisabled: Boolean = true;
	private delivered: Boolean = false;
	private editClient: Client = null;
	private dataClient: Client[] = null

	private storeTransporteur = storeTransporteur
	private storeClient = storeClient
	private storeCommande = storeCommande
	private storeLongueursVente = storeLongueursVente;
	private storeBoisType = storeBoisType;

	private menu = false;
	private menu2 = false;

	public constructor() {
		super(
			storeVente,
			'Vente modifié',
			'Vente créé',
		);
	}

	@Emit()
	private async onNext(): Promise<void> {
		if (this.item.commande) {
			this.item.client = this.item.commande.client
			this.item.boisType = this.item.commande.boisType
			this.item.longueursVente = this.item.commande.longueursVente
			if (!this.item.id)
				this.item.transporteur = null
		}
		this.step++
	}

	@Emit()
	private onPrev() {
		this.step--
	}

	public newClient() {
		this.editClient = new Client();
		this.refresh();
	}

	public watcher() {
		if (this.item.delivered) {
			this.item.dateDelivery = new Date()
			this.delivered = true;
		} else {
			this.item.dateDelivery = null
			this.delivered = false;
		}
	}

//	@Emit()
//	private onNext() {
//		if ((!this.item.address) || (this.item.address === null) )
//		{
//			this.item.address = this.item.name;
//		}
//		this.step = 2;
//	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await storeTransporteur.dispatch('getC', {filters: false});
		await storeLongueursVente.dispatch('getC', {filters: false});
		await storeBoisType.dispatch('getC', {filters: false});
		await storeClient.dispatch('getAll');
		this.dataClient = storeClient.state.all.data;
		await storeCommande.dispatch('getCommandes');
		await super.mounted();
		await this.loadClient()
		this.checkInputs();
		if (this.item.id)
			this.step = 2
	}

	public async refresh(): Promise<void> {
		if (this.item) {
			await storeClient.dispatch('getAll');
			this.dataClient = storeClient.state.all.data;
			this.item.client = storeClient.state.client
		}
		await super.refresh();
		this.checkInputs();
		//console.log('route vente edit = ' + this.$route.name);
	}

	@Stored(() => storeClientPrix) private client!: Client;

	private clientChange(): void {
		this.loadClient();
		this.prixStere();
		this.checkInputs();
	}

	private checkInputs(): void {
		if (this.item)
		{
			if (!this.item.transporteur || !this.item.client)
			{
				this.savedisabled = true;
			}
			else
			{
				this.savedisabled = false;
			}
		}
	}

	private async loadClient(): Promise<void> {
		if (this.item.client) {
			await storeClientPrix.dispatch('get', this.item.client.id)
		}
	}

	private prixStere(): void {
		let essence = null
		let longueur = null

		if (this.item.boisType != null || essence != this.item.boisType) {
			essence = this.item.boisType
		}
		if (this.item.longueursVente != null || longueur != this.item.longueursVente) {
			longueur = this.item.longueursVente
		}

		if (this.client != null && essence != null && longueur != null) {
			this.calculPrix(this.client, essence, longueur)
		}
	}

	private calculPrix(client, essence, longueur): void {
		if (client.prixClients && client.prixClients.length) {
			for (const prixClient of client.prixClients) {
				if (prixClient.longueursVente.name == longueur.name) {
					if (this.item.venduNonLivre == true)
					{
						this.item.prixStere = parseFloat(prixClient.montantNonLivre)
						this.$forceUpdate();
					}
					else
					{
						if (essence.name.toLowerCase().includes('divers')) {
							this.item.prixStere = parseFloat(prixClient.montantDivers)
							this.$forceUpdate();
						} else {
							this.item.prixStere = parseFloat(prixClient.montant)
							this.$forceUpdate();
						}
					}
				}
			}
		}
	}

}
